import { siteInfo } from '@/mocks/site';
import { hotVideos, newVideos } from '@/mocks/videos';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import VideoGrid from './components/VideoGrid';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.fullName,
  url: siteInfo.url,
  logo: `${siteInfo.url}/logo.png`,
  description: siteInfo.description,
  email: siteInfo.email,
  telephone: siteInfo.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: siteInfo.address,
    addressLocality: '北京',
    addressCountry: 'CN',
  },
  sameAs: [siteInfo.social.weibo],
};

const webSiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.fullName,
  url: siteInfo.url,
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteInfo.url}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const webPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${siteInfo.fullName} - 首页`,
  description: siteInfo.description,
  url: siteInfo.url,
  isPartOf: {
    '@type': 'WebSite',
    name: siteInfo.fullName,
    url: siteInfo.url,
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}
      />

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <VideoGrid
          title="热门推荐"
          subtitle="全网最受欢迎的视频内容，每日更新"
          videos={hotVideos}
          linkTo="/category/hot"
          badge="HOT"
        />
        <VideoGrid
          title="最新上线"
          subtitle="刚刚更新的最新视频，别错过任何精彩"
          videos={newVideos}
          linkTo="/category/hot"
          badge="NEW"
        />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}